import React, { createContext, useContext, ReactNode } from 'react';
import { SelfDeclarationHistory } from 'api/generated/models';
import { useGetV1SelfDeclaration } from 'api/generated/endpoint';

type UserDeclarationsContextType = {
    data: SelfDeclarationHistory | undefined;
    isPending: boolean;
    error: any;
};

const UserDeclarationsContext = createContext<
    UserDeclarationsContextType | undefined
>(undefined);

export const UserDeclarationsProvider: React.FC<{
    children: ReactNode;
    userInfo: any;
}> = ({ children, userInfo }) => {
    const {
        data: SelfDeclarationHistory,
        isPending: SelfDeclarationHistoryIsPending,
        error: SelfDeclarationHistoryError,
    } = useGetV1SelfDeclaration({
        query: {
            enabled: !!userInfo,
        },
    });

    return (
        <UserDeclarationsContext.Provider
            value={{
                data: SelfDeclarationHistory,
                isPending: SelfDeclarationHistoryIsPending,
                error: SelfDeclarationHistoryError,
            }}
        >
            {children}
        </UserDeclarationsContext.Provider>
    );
};

export const useUserDeclarations = () => {
    const context = useContext(UserDeclarationsContext);
    if (context === undefined) {
        throw new Error(
            'useUserDeclarations must be used within a UserDeclarationsProvider'
        );
    }
    return context;
};
